import { render, staticRenderFns } from "./Packages_comp.vue?vue&type=template&id=27f1b888&scoped=true&"
import script from "./Packages_comp.vue?vue&type=script&lang=js&"
export * from "./Packages_comp.vue?vue&type=script&lang=js&"
import style0 from "./Packages_comp.vue?vue&type=style&index=0&id=27f1b888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1b888",
  null
  
)

export default component.exports